<template>
  <div class="page-report" v-if="journeyData.length > 0">
    <div class="block-flex">
      <div class="flex-nav static1" v-for="(item, index) in journeyData" :key="index" @click="handleChangeJounery(item)"
        :class="classes(item)">
        <img v-if="item.name === currentJourney.name" :src="staticedImage(item)" class="bg-img" />
        <img v-else :src="staticImage(item)" class="bg-img" />
        <div class="txt1">{{ item && item.name }}</div>
      </div>
    </div>
    <div class="block-info block-level">
      <van-collapse v-model="activeNames">
        <van-collapse-item class="level-item" v-for="(item, index) in journeyStageData.stages" :key="index" :name="index">
          <template #title>
            <div class="col-title">
              <div class="state-name">
                {{ item.stageNo.substring(0, 2) === 'U4' ? 'U3' : item.stageNo.substring(0, 2) }}
              </div>
              <div class="state-title">{{ item && item.name }}</div>
            </div>
          </template>
          <div class="level-title">
            <img src="../../assets/images/journey/report_tab_standard@2x.png" class="icon-title" alt="" />
            <span v-html="item.evaluationCriteria"></span>
          </div>
          <div class="level-course" v-for="(_item, _key) in item.totalList" :key="_key">
            <div class="title-txt">{{ _item.type }}</div>
            <div v-for="(item_check, key_check) in _item.list" :key="key_check">
              <div class="txt" v-if="item_check.name">
                {{ item_check.name }}
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <barComponents></barComponents>
  </div>
</template>

<script>
import detailJson from './index.json'
import { getJourneyList, getStageList } from '@/api/growthJourney'
import barComponents from '../../components/barComponents.vue'
import { trackPageView } from '@/utils/trace'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'JourneyReport',
  components: {
    barComponents
  },
  data () {
    return {
      activeNames: [0, 1, 2, 3, 4, 5],
      activeCourse: ['1'],
      detail: detailJson,
      journeyData: [],
      journeyStageData: [],
      currentJourney: {},
      pathToFrom: {},
      curPageTitle: '成长旅程'
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    staticedImage () {
      return item => {
        if (item.name === '电生理成长之旅') {
          return require('@/assets/images/journey/staticed1.png')
        } else if (item.name === '阵发性房颤进阶之旅') {
          return require('@/assets/images/journey/staticed2.png')
        } else if (item.name === '持续性房颤菁英之旅') {
          return require('@/assets/images/journey/staticed3.png')
        } else if (item.name === '超声视界之旅') {
          return require('@/assets/images/journey/staticed4.png')
        } else {
          return require('@/assets/images/journey/staticed1.png')
        }
      }
    },
    staticImage () {
      return item => {
        if (item.name === '电生理成长之旅') {
          return require('@/assets/images/journey/static1.png')
        } else if (item.name === '阵发性房颤进阶之旅') {
          return require('@/assets/images/journey/static2.png')
        } else if (item.name === '持续性房颤菁英之旅') {
          return require('@/assets/images/journey/static3.png')
        } else if (item.name === '超声视界之旅') {
          return require('@/assets/images/journey/static4.png')
        } else {
          return require('@/assets/images/journey/static1.png')
        }
      }
    },
    classes () {
      return item => {
        return {
          cur: item.name === this.currentJourney.name,
          static1: item.name === '电生理成长之旅',
          static2: item.name === '阵发性房颤进阶之旅',
          static3: item.name === '持续性房颤菁英之旅',
          static4: item.name === '超声视界之旅'
        }
      }
    }
  },
  mounted () {
    this.getJourneyInfo()
  },
  destroyed () {
  },
  methods: {
    // 获取所有旅程
    getJourneyInfo () {
      let params = {
        multiCode: this.userInfo.multiCode
      }
      getJourneyList(params)
        .then(res => {
          if (res && res.data) {
            if (res.data.length > 0) {
              let arr1 = JSON.parse(JSON.stringify(res.data))
              arr1 = arr1.filter(item => {
                return item.isJoinReport === 'true'
              })
              arr1.sort((a, b) => {
                return a.sequence - b.sequence
              })
              // let arr2 = []
              // for (let i = 0; i < arr1.length; i++) {
              //   const element = arr1[i]
              //   if (element.name === '电生理成长之旅') {
              //     arr2[0] = element
              //   } else if (element.name === '阵发性房颤进阶之旅') {
              //     arr2[1] = element
              //   } else if (element.name === '持续性房颤菁英之旅') {
              //     arr2[2] = element
              //   } else if (element.name === '超声视界之旅') {
              //     arr2[3] = element
              //   }
              // }
              this.journeyData = JSON.parse(JSON.stringify(arr1))
              this.currentJourney = this.journeyData[0]
            }
          }
        })
        .then(() => {
          this.getStageInfo()
        })
    },
    // 获取旅程下的所有阶段
    getStageInfo () {
      let params = {
        multiCode: this.userInfo.multiCode,
        // journeyId: '1636263092770226177'
        journeyId: this.currentJourney.id
      }
      getStageList(params).then(res => {
        if (res && res.data) {
          let arr1 = JSON.parse(JSON.stringify(res.data))
          for (let i = 0; i < arr1.stages.length; i++) {
            const element1 = arr1.stages[i]
            // 处理换行问题
            let eva = element1.evaluationCriteria
            let pattern1 = /\(+[0-9]+\)/gi
            let pattern2 = /;|:/gi
            if (pattern1.test(eva)) {
              element1.evaluationCriteria = eva.replace(pattern1, rs => {
                return '<br>' + rs
              })
            } else if (pattern2.test(eva)) {
              element1.evaluationCriteria = eva.replace(pattern2, rs => {
                return rs + '<br>'
              })
            }
            element1.totalList = []
            // 处理tasks数据问题
            let stageTasks = element1.tasks
            if (stageTasks.length > 0) {
              // 拿到所有任务类型的名称
              let stageTaskTypeList = stageTasks.map(item => {
                return item.type
              })
              const resultArr = Array.from(new Set(stageTaskTypeList))
              // 把相同的任务类型放进同一个数组内
              let arri = []
              for (let j = 0; j < resultArr.length; j++) {
                const element2 = resultArr[j]
                let arrj = stageTasks.filter(item1 => {
                  return item1.type === element2
                })
                let obj = {}
                obj.type = element2
                obj.list = arrj
                arri.push(obj)
              }
              element1.totalList = JSON.parse(JSON.stringify(arri))
            }
            // 处理活动
            let stageActivity = element1.academicActivities
            if (stageActivity.length > 0) {
              let activityObj = {
                type: '学术活动',
                list: stageActivity
              }
              element1.totalList.push(activityObj)
            }
            // 处理课程
            let stageCourse = element1.courses
            if (stageCourse.length > 0) {
              for (let k = 0; k < stageCourse.length; k++) {
                const element2 = stageCourse[k]
                element2.name = element2.courseDisplayName
              }
              let courseObj = {
                type: '心相伴课程',
                list: stageCourse
              }
              element1.totalList.push(courseObj)
            }
          }
          // 排序
          arr1.stages = arr1.stages.sort((a, b) => {
            return b.sequence - a.sequence
          })
          this.journeyStageData = JSON.parse(JSON.stringify(arr1))
        }
      })
      setTimeout(() => {
        window.sessionStorage.setItem('traceTitle', `${this.curPageTitle + '-' + this.currentJourney.displayName}`)
      })
    },
    async handleChangeJounery (item) {
      window.sessionStorage.setItem('traceTitle', `${this.curPageTitle + '-' + this.currentJourney.displayName}`)
      await trackPageView(this.pathToFrom.to, this.pathToFrom.to, this.defaultTime) // 上报数据
      this.currentJourney = item
      this.getStageInfo()
      this.activeNames = [0, 1, 2, 3, 4, 5]
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.page-report {
  background-color: #f0f1f6;
  min-height: 100vh;
  padding-bottom: 60px;
  box-sizing: border-box;

  .block-flex {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 95px;
    padding-left: 12px;
    padding-top: 16px;
    box-sizing: border-box;
    background: linear-gradient(270deg, #ffb063 0%, #ff5a0b 100%);
    margin-bottom: 23px;

    .flex-nav {
      display: flex;
      align-items: center;
      margin-right: 8px;
      box-sizing: border-box;
      position: relative;
      font-size: 14px;

      &.static1 {
        width: 89px;
        height: 60px;
        padding-left: 15px;
        padding-right: 13px;
      }

      &.static2 {
        width: 91px;
        height: 60px;
        padding-left: 11px;
        padding-right: 2px;
      }

      &.static3 {
        width: 100px;
        height: 60px;
        padding-left: 15px;
        padding-right: 10px;
      }

      &.static4 {
        width: 63px;
        height: 60px;
        padding-left: 12px;
        padding-right: 2px;
        margin-right: 5px;
      }

      &.cur {
        .bg-img {
          height: 70px;
        }

        .txt1 {
          color: #000000;
          position: relative;
        }
      }

      .txt1 {
        line-height: 20px;
        font-size: 14px;
        color: #fff;
        position: relative;
      }

      .bg-img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
      }
    }
  }

  .block-info {
    padding: 0 12px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      padding-left: 15px;
      position: relative;
      margin-top: 16px;
      margin-bottom: 15px;

      &::before {
        position: absolute;
        left: 5px;
        width: 4px;
        height: 12px;
        border-radius: 4px;
        background-color: #EB1700;
        top: 50%;
        transform: translateY(-50%);
        content: '';
      }
    }
  }

  .block-level {
    padding: 17px 15px;
    padding-top: 0;
    box-sizing: border-box;

    /deep/.level-item {
      padding: 16px 15px;
      box-sizing: border-box;
      background-color: #fff;
      margin-bottom: 23px;
      border-radius: 8px;

      .van-cell {
        overflow: visible;
      }

      .col-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #000;

        .report-img {
          position: absolute;
          top: -22px;
          left: 0;
          height: 15px;
          width: auto;
          z-index: 9;
        }

        .state-name {
          font-size: 14px;
          // width: 50px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin-right: 10px;
          border-radius: 100px;
          background: linear-gradient(270deg, #ff941c 0%, #EB1700 100%);
          color: #fff;
        }
      }

      .van-collapse-item__wrapper {
        padding-left: 60px;
        box-sizing: border-box;
      }

      &::before {
        position: absolute;
        left: 37px;
        border-left: 1px dashed #979797;
        content: '';
        height: calc(100% - 56px);
        top: 40px;
        transform: inherit;
      }

      .txt {
        font-size: 12px;
        color: #333333;
        line-height: 20px;
        margin-top: 8px;
        padding-left: 8px;
        position: relative;

        &::before {
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #EB1700;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          content: '';
        }
      }

      &.cur_level {
        .van-collapse-item {
          &::before {
            background: linear-gradient(270deg, rgba(255, 91, 12, 0) 0%, #EB1700 100%) !important;
          }
        }

        &::after {
          position: absolute;
          left: 0;
          border-left: 7px solid #EB1700;
          content: '';
          height: 100%;
          top: 0;
          transform: inherit;
          border-bottom-left-radius: 8px;
          border-top-left-radius: 8px;
        }
      }

      /deep/.van-cell__title {
        font-size: 16px;
        color: #000;
        font-weight: 500;
      }

      .level-title {
        display: flex;
        font-size: 12px;
        color: #333333;
        margin-top: 9px;
        margin-bottom: 15px;

        .level-txt {
          margin-right: 10px;
        }

        .icon-title {
          width: 53px;
          height: 20px;
          margin-right: 3px;
        }
      }

      .tip {
        font-size: 12px;
        color: #EB1700;
        margin-bottom: 4px;
      }

      .level-course {
        border-radius: 2px;
        position: relative;
        margin-bottom: 8px;
        padding: 6px 7px;
        box-sizing: border-box;

        &:nth-last-child(1) {
          margin-bottom: 0;
        }

        &::before {
          background: linear-gradient(270deg, rgba(171, 172, 204, 0.14) 0%, #abaccc 100%);
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.17;
          z-index: 0;
          content: '';
        }

        .title-txt {
          font-size: 12px;
          color: #333333;
          line-height: 30px;
        }

        .van-cell__title {
          font-size: 12px;
          color: #333333;
        }

        .van-cell {
          background: transparent;
        }

        .van-collapse-item__wrapper {
          padding-left: 0;
        }

        .van-collapse-item {
          margin-bottom: 8px;
          padding: 6px 7px;
          box-sizing: border-box;
          z-index: 9;

          &::before {
            background: linear-gradient(270deg, rgba(171, 172, 204, 0.14) 0%, #abaccc 100%);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.17;
            z-index: -1;
            content: '';
          }

          &::after {
            border: none;
          }

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .van-collapse-item__content {
            background: transparent;
          }
        }
      }
    }
  }
}

/deep/.van-cell {
  padding: 0;
}

/deep/.van-collapse-item__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/growthJourney/growthJourney.vue